/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {fetchCorrosionRateAlertsData, fetchAlertsCount} from "../../../api/alertsApi"
import { toast } from "react-toastify";



function useGetCorrosionAlertsData(filter,pageSize,currentPage,order_by,order_dir, refreshToggle, isTokenReady) {
    console.log("useGetCorrosionAlertsData called with:", {filter, pageSize, currentPage, order_by, order_dir, refreshToggle, isTokenReady});
    const [data, setData] = useState({
        alertsList: [],
        alertsCount: 0
    });
    const offset = (currentPage - 1) * pageSize;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (isTokenReady){
            setLoading(true);
            Promise.all([
                fetchCorrosionRateAlertsData(filter, pageSize, offset, order_by, order_dir),
                fetchAlertsCount(filter)

            ])
            .then(([alertsList, alertsCount]) => {
                setData({
                    alertsList,
                    alertsCount
                });
                console.log("Data fetching completed");
                console.log("Loading finished");
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                toast.error(`Cannot fetch Corrosion Alerts List`);
                setError(error);
            })
        }
    }, [currentPage, order_by, order_dir, filter, refreshToggle, isTokenReady]);
    console.log("loading", loading, "error", error, "data", data);
    return { data, loading, error };
}


export default useGetCorrosionAlertsData;